// filters/index.js
export function amountInWords(num) {

  if (num === null || num === '' || isNaN(num)) return '';
  // 处理负数
  const head = num < 0 ? '欠' : '';
  num = Math.abs(num);

  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
  const fraction = ['角', '分'];

  let s = '';
  // 小数部分处理
  // 注意：浮点数精度会导致如 1.13*100 = 112.999...，从而 Math.floor 取位错误
  // 先把金额四舍五入到“分”，再拆分出角/分
  const cents = Math.round(num * 100);
  const frac = cents % 100;
  for (let i = 0; i < fraction.length; i++) {
    const n = i === 0 ? Math.floor(frac / 10) : (frac % 10);
    s += (digit[n] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';

  // 整数部分处理
  num = Math.floor(cents / 100);
  for (let i = 0; i < unit[0].length && num > 0; i++) {
    let p = '';
    for (let j = 0; j < unit[1].length && num > 0; j++) {
      p = digit[num % 10] + unit[1][j] + p;
      num = Math.floor(num / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }

  return head + s
    .replace(/(零.)*零元/, '元')
    .replace(/(零.)+/g, '零')
    .replace(/^整$/, '零元整');
}

export function relativeDateFilter(value) {
  if (!value) return '';

  // 注意：new Date('YYYY-MM-DD') 在多数环境会按 UTC 解析，东八区会变成 08:00:00
  // 这里对纯日期字符串按“本地 0 点”解析，避免误判带时分秒
  let inputDate;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map((n) => Number(n));
    inputDate = new Date(y, m - 1, d, 0, 0, 0, 0);
  } else {
    inputDate = new Date(value);
  }
  if (Number.isNaN(inputDate.getTime())) return '';
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const diffTime = inputDate.getTime() - today.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  let base = '';
  switch (diffDays) {
    case 0: base = '今天'; break;
    case 1: base = '明天'; break;
    case 2: base = '后天'; break;
    case 3: base = '大后天'; break;
    case -1: base = '昨天'; break;
    case -2: base = '前天'; break;
    case -3: base = '大前天'; break;
    default:
      if (diffDays > 0) base = `${diffDays}天后`;
      if (diffDays < 0) base = `${Math.abs(diffDays)}天前`;
  }

  const hasHms = inputDate.getHours() !== 0 || inputDate.getMinutes() !== 0 || inputDate.getSeconds() !== 0;
  if (!hasHms) return base;

  const pad2 = (n) => String(n).padStart(2, '0');
  const time = `${pad2(inputDate.getHours())}:${pad2(inputDate.getMinutes())}:${pad2(inputDate.getSeconds())}`;
  return base ? `${base}的 ${time}` : time;
}